(function () {
  var mapEl = document.getElementById('weather-variant-map');
  if (!mapEl) return;

  var precomputed;
  try {
    precomputed = JSON.parse(mapEl.textContent);
  } catch (e) {
    precomputed = {};
  }

  var TARGET_FINISH = precomputed.__meta_finish || null;
  var APPLY_IMAGE_SWAP = !!precomputed.__meta_images;
  var THIRD_IMAGE_INDEX = 2;
  var fetchCache = {};

  function withWidth(url) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=600';
  }

  function findFinishIndex(options) {
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      var name = (opt && typeof opt === 'object') ? opt.name : opt;
      if (name === 'Finish') return i;
    }
    return -1;
  }

  function buildFromProductJson(productJson) {
    var patch = {};

    if (TARGET_FINISH) {
      var idx = findFinishIndex(productJson.options);
      if (idx !== -1) {
        var key = 'option' + (idx + 1);
        var match = productJson.variants.find(function (v) { return v[key] === TARGET_FINISH; });
        if (match) patch.variant = match.id;
      }
    }

    if (APPLY_IMAGE_SWAP && productJson.images && productJson.images.length >= 3) {
      patch.image = withWidth(productJson.images[THIRD_IMAGE_INDEX]);
      patch.hover = withWidth(productJson.images[0]);
    }

    return patch;
  }

  function resolvePatch(handle) {
    if (handle in precomputed) {
      return Promise.resolve(precomputed[handle]);
    }
    if (!fetchCache[handle]) {
      fetchCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) { return data ? buildFromProductJson(data) : null; })
        .catch(function () { return null; });
    }
    return fetchCache[handle];
  }

  function alreadyShows(img, targetUrl) {
    if (!img) return false;
    var targetFile = targetUrl.split('?')[0].split('/').pop();
    var current = img.currentSrc || img.src || img.getAttribute('data-src') || '';
    return current.indexOf(targetFile) !== -1;
  }

  function swapImage(img, url) {
    img.setAttribute('src', url);
    img.setAttribute('data-src', url);
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.classList.remove('lazyload');
    img.classList.add('lazyloaded');
  }

  function applyPatch(link, patch) {
    if (patch.variant) {
      var url = new URL(link.href, window.location.origin);
      if (!url.searchParams.has('variant')) {
        url.searchParams.set('variant', patch.variant);
        link.setAttribute('href', url.pathname + url.search);
      }
    }

    if (patch.image) {
      var img = link.querySelector('img');
      if (img && !alreadyShows(img, patch.image)) {
        swapImage(img, patch.image);
      }
    }

    if (patch.hover) {
      var secondaryImg = link.querySelector('img.secondary');
      if (secondaryImg && !alreadyShows(secondaryImg, patch.hover)) {
        swapImage(secondaryImg, patch.hover);
      }
    }
  }

  function processLink(link) {
    if (link.dataset.weatherPatchApplied) return;

    var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!match) return;

    link.dataset.weatherPatchApplied = 'true';

    resolvePatch(match[1]).then(function (patch) {
      if (patch) applyPatch(link, patch);
    });
  }

  function scan() {
    document.querySelectorAll('a[href*="/products/"]').forEach(processLink);
  }

  scan();

  var observer = new MutationObserver(scan);
  observer.observe(document.body, { childList: true, subtree: true });
})();